import { createFileRoute } from "@tanstack/react-router";
import InsightsPage from "@/pages/InsightsPage";
import { buildHead, SITE_URL } from "@/lib/seo-head";

export const Route = createFileRoute("/insights/")({
  head: () =>
    buildHead({
      title: "Interior Design Insights & Articles | Abacus Bahrain",
      description:
        "Expert insights on interior design, fit-out, joinery, LED lighting, natural stone and colour psychology for commercial interiors in Bahrain and the GCC.",
      path: "/insights",
      schemaJson: {
        "@context": "https://schema.org",
        "@type": "Blog",
        name: "Abacus Insights",
        url: `${SITE_URL}/insights`,
      },
    }),
  component: InsightsPage,
});
